<template>
  <div :class="['service-item-landscape', 'round-corner', {'disabled': data.disabled}]" @click.stop="goDetail">
    <div class="service-content">
      <p class="service-name">{{ data.SXMC }}</p>
      <div class="tags">
        <van-tag
            v-if="data.SXBH && data.SXBH != ''"
            :color="data.disabled? 'rgba(51, 51, 51, .06)' : mainColorLight"
            :text-color="data.disabled? 'rgba(153, 153, 153, 1)' : mainColor"
            size="large">{{ data.SXBH }}</van-tag>
        <van-tag
            v-if="data.FWDXTEXT && data.FWDXTEXT != ''"
            :color="data.disabled? 'rgba(51, 51, 51, .06)' : mainColorLight"
            :text-color="data.disabled? 'rgba(153, 153, 153, 1)' : mainColor"
            size="large">{{ data.FWDXTEXT }}</van-tag>
        <van-tag
            v-if="data.SXXZTEXT && data.SXXZTEXT != ''"
            :color="data.disabled? 'rgba(51, 51, 51, .06)' : mainColorLight"
            :text-color="data.disabled? 'rgba(153, 153, 153, 1)' : mainColor"
            size="large">{{ data.SXXZTEXT }}</van-tag>
        <van-tag
            v-if="data.BJMSTEXT && data.BJMSTEXT != ''"
            :color="data.disabled? 'rgba(51, 51, 51, .06)' : mainColorLight"
            :text-color="data.disabled? 'rgba(153, 153, 153, 1)' : mainColor"
            size="large">{{ data.BJMSTEXT }}</van-tag>
      </div>
    </div>
  </div>
</template>

<script>
  import {Tag} from 'vant';
  import {fetchRgbColer} from '@/utils/commons'
  import {mapState} from "vuex"
  import {getThemeParams} from "@/utils/theme";
	export default {
		name: 'MatterItemLandscape',
    props: {
		  data: {
		    type: Object,
		    default: () => {
		      return {}
        }
      }
    },
    components:{
      'van-tag':Tag,
    },
		computed: {
      ...mapState(['matterObjects','matterNatures','matterModels','matterDepts']),
		  mainColor(){
        if (getThemeParams('main_color')){
          return getThemeParams('main_color');
        } else {
          return '#003c88'
        }
      },
      mainColorLight(){
        let rgb = fetchRgbColer(this.mainColor)
        return 'rgba('+rgb.join(',')+',0.08)'
      }
		},
		methods: {
      fetchRgbColer,
      getThemeParams,
      goDetail() {
        this.$emit('matterHandle', this.data)
      }
		},
		mounted() {
		}
	}
</script>

<style scoped lang="scss">
@import "~@/assets/css/theme/theme.scss";
  .service-item-landscape{
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    padding:15px;
    margin-bottom:12px;
    border-radius:5px;
    background: #ffffff;
    .service-content{
      .service-name{
        height: 35px;
        line-height: 35px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        @extend .font16;
      }
      .tags{
        .van-tag{
          margin-left:5px;
          @extend .font13;
        }
      }
    }
    &.disabled{
      background: #f0f0f0;
      .service-content{
        .service-name {
          color:rgba(153, 153, 153, 1);
        }
        .tags{
          margin-bottom: 5px;
        }
      }
    }
  }
</style>
